export const systemActionTypes = {
	SET_LOADING: 'SET_LOADING',
	SET_LOCATION: 'SET_LOCATION',
	SET_STUDIO_ID: 'SET_STUDIO_ID',
	SET_STUDIO: 'SET_STUDIO',
	SET_BOOKING_REQUEST: 'SET_BOOKING_REQUEST',
};
